// import { pathObj } from "@/services/apiPath";
import { pathObj } from "../../services/apiPath";
import {
  apiDelete,
  apiGet,
  apiPost,
  apiPut,
} from "../../services/httpServices";
import { set } from "react-hook-form";

const getDashboardApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(pathObj.DASHBOARD_LIST, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the profile"
    );
    console.error(error);
  }
};

const getUsersApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(pathObj.USER_LIST, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the profile"
    );
    console.error(error);
  }
};

const getPaymentUserApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(pathObj.PAYMENT_LIST, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the profile"
    );
    console.error(error);
  }
};

const addAndUpdateUser = async (formData, userData, notification, callback) => {
  callback?.(true, true); // Start loading state
  try {
    let response;
    if (userData?.modeType === "add") {
      response = await apiPost(
        pathObj.ADD_USER,
        formData,
        "multipart/form-data"
      );
    } else {
      response = await apiPut(
        `${pathObj.EDIT_USER}/${userData?.id}`,
        formData,
        "multipart/form-data"
      );
    }

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false); // Stop loading state
    } else {
      callback?.(false, true); // Error state
      notification.error(message || "Update Profile failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the profile.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const editUserApi = async (formData, userData, notification, callback) => {
  callback?.(true, true);
  try {
    const response = await apiPut(
      `${pathObj.EDIT_USER}/${userData?.id}`,
      formData,
      "multipart/form-data"
    );

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false); // Stop loading state
    } else {
      callback?.(false, true); // Error state
      notification.error(message || "Update Profile failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the profile.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const ViewUsersApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(`${pathObj.USER_VIEW}/${data?.id}`);
    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the profile"
    );
    console.error(error);
  }
};

const deleteUserApi = async (userData, notification, callback) => {
  callback?.(true, true);
  try {
    const response = await apiDelete(`${pathObj.DELETE_USER}/${userData?.id}`);

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false);
    } else {
      callback?.(false, true);
      notification.error(message || "Delete user failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the profile.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const changeStatusApi = async (data, notification, callback) => {
  callback?.(true, true); // Start loading state
  try {
    let response = await apiPut(
      `${pathObj.CHANGE_USER_STATUS}/${data?.id}`,
      data
    );

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false); // Stop loading state
    } else {
      callback?.(false, true); // Error state
      notification.error(message || "Update Profile failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the profile.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const getTeamApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(pathObj.TEAM, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(error.message || "An error occurred while get the team");
    console.error(error);
  }
};

const deleteTeamApi = async (userData, notification, callback) => {
  callback?.(true, true);
  try {
    const response = await apiDelete(`${pathObj.DELETE_TEAM}/${userData?.id}`);

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false);
    } else {
      callback?.(false, true);
      notification.error(message || "Delete user failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the team.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const addAndUpdateTeam = async (formData, userData, notification, callback) => {
  callback?.(true, true); // Start loading state
  try {
    let response;
    if (userData?.modalTypes == "add") {
      response = await apiPost(
        pathObj.ADD_TEAM,
        formData,
        "multipart/form-data"
      );
    } else {
      response = await apiPut(
        `${pathObj.EDIT_TEAM}/${userData?.id}`,
        formData,
        "multipart/form-data"
      );
    }

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false); // Stop loading state
    } else {
      callback?.(false, true); // Error state
      notification.error(message || "Update Team failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the team.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const AcceptRejectApi = async (data, id, notification, callback) => {
  callback?.(true, true); // Start loading state
  try {
    let response = await apiPost(`${pathObj.ACCEPT_REJECT}/${id}`, data);

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false);
    } else {
      callback?.(false, true);
      notification.error(message || "Accept & Reject failed");
    }
  } catch (error) {
    callback?.(false, true);
    const errorMessage =
      error.message || "An error occurred while Accept & Reject.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const getSuvicharApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(pathObj.GET_SUVICHAR, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(error.message || "An error occurred while get the team");
    console.error(error);
  }
};

const deleteSuvicharApi = async (userData, notification, callback) => {
  callback?.(true, true);
  try {
    const response = await apiDelete(
      `${pathObj.DELETE_SUVICHAR}/${userData?.id}`
    );

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false);
    } else {
      callback?.(false, true);
      notification.error(message || "Delete user failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the team.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const addAndUpdateSuvichar = async (data, userData, notification, callback) => {
  callback?.(true, true);
  try {
    let response;
    if (userData?.modalTypes == "add") {
      response = await apiPost(pathObj.ADD_SUVICHAR, data);
    } else {
      response = await apiPut(`${pathObj.EDIT_SUVICHAR}/${userData?.id}`, data);
    }

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false); // Stop loading state
    } else {
      callback?.(false, true); // Error state
      notification.error(message || "Update Team failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the team.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const getEmploymentApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(pathObj.GET_EMPLOYMENT, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the employment"
    );
    console.error(error);
  }
};

const addAndUpdateEmployment = async (
  data,
  userData,
  notification,
  callback
) => {
  callback?.(true, true); // Start loading state
  try {
    let response;
    if (userData?.modalTypes == "add") {
      response = await apiPost(pathObj.ADD_EMPLOYMENT, data);
    } else {
      response = await apiPut(
        `${pathObj.EDIT_EMPLOYMENT}/${userData?.id}`,
        data
      );
    }

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false); // Stop loading state
    } else {
      callback?.(false, true); // Error state
      notification.error(message || "Update job post failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the job post.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const deleteJobApi = async (userData, notification, callback) => {
  callback?.(true, true);
  try {
    const response = await apiDelete(
      `${pathObj.DELETE_EMPLOYMENT}/${userData?.id}`
    );

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false);
    } else {
      callback?.(false, true);
      notification.error(message || "Delete user failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the job post.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const getContactUsApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(pathObj.GET_CONTACT_US, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the contact us"
    );
    console.error(error);
  }
};

const getSuggestionApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(pathObj.GET_SUGGESTION, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the contact us"
    );
    console.error(error);
  }
};

export {
  getDashboardApi,
  getUsersApi,
  addAndUpdateUser,
  editUserApi,
  changeStatusApi,
  deleteUserApi,
  getTeamApi,
  deleteTeamApi,
  addAndUpdateTeam,
  getPaymentUserApi,
  AcceptRejectApi,
  getSuvicharApi,
  deleteSuvicharApi,
  addAndUpdateSuvichar,
  getEmploymentApi,
  addAndUpdateEmployment,
  deleteJobApi,
  ViewUsersApi,
  getContactUsApi,
  getSuggestionApi,
};
